import { createGlobalStyle } from 'styled-components';

const GlobalStylesComponent = createGlobalStyle`
  /* Global Reset */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* Global Container */
  .report-type-container {
    margin: 0 auto;
    width: 100%;
    min-height: 100vh;
    background-color: #f8f9fc;
    position: relative;
  }

  /* Global Table Styles */
  .table-responsive {
    position: relative;
    z-index: 1;
  }

  .table {
    width: 100%;
    margin-bottom: 0;
    background-color: #fff;
  }

  /* Global Loading Styles */
  .loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
  }

  /* Global Error Styles */
  .error-container {
    padding: 1rem;
    text-align: center;
    color: #dc3545;
  }

  /* Global Empty State */
  .empty-state {
    text-align: center;
    padding: 2rem;
    color: #6c757d;
  }

  /* Global Action Buttons */
  .action-buttons {
    display: flex;
    gap: 4px;
    align-items: center;
  }

  .action-button {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0.25rem;
    transition: all 0.2s ease;
  }

  /* Global Tooltips */
  .tooltip {
    position: absolute;
    z-index: 1000;
    background: #1D2127;
    color: #fff;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.75rem;
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease;
  }

  /* Global Modal Styles */
  .modal {
    z-index: 1050;
  }

  .modal-content {
    border-radius: 8px;
    border: none;
  }

  .modal-header {
    border-bottom: 1px solid #e9ecef;
    padding: 1rem;
  }

  .modal-body {
    padding: 1rem;
  }

  .modal-footer {
    border-top: 1px solid #e9ecef;
    padding: 1rem;
  }

  /* Global Form Styles */
  .form-group {
    margin-bottom: 1rem;
  }

  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  .form-control:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

  /* Global Button Styles */
  .btn {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: all 0.15s ease-in-out;
  }

  /* Responsive Utilities */
  @media (max-width: 768px) {
    .report-type-container {
      padding: 1rem;
    }
    
    .table-responsive {
      margin: 0 -1rem;
    }
  }
`;

export default GlobalStylesComponent; 